import { QuoteState } from '~/lib/api/smartsend/types';
import { IossNumberSource } from '../consts/ItemMetaConstants';
export const IossIsPrePaid = (iossNumberSource: string) => ['Api', 'Defaults'].includes(iossNumberSource);
export const IossIsRequired = (validation: QuoteState | undefined): boolean =>
  !!validation?.ItemValidation?.find((x) => x.name === IossNumberSource && x.required);
